import React from 'react';

const Spinner = (props) => (
  // <div className="Loader">Loading...</div>
  <div className="Loader"></div>
);

export default Spinner;